import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';


import { Font } from '@react-pdf/renderer';
import { style } from '../../components/pdf/fontstyles';
import { AutoText } from '../../components/pdf/autoText';


const styles = StyleSheet.create({
  table: {
            
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  row: {
    flexDirection: 'row',
    borderBottom: '1px solid #000',
  },
  cell: {
    padding: 5,
    borderRight: '1px solid #000',
  },
  headerCell: {
    fontWeight: 'bold',
    backgroundColor: '#f2f2f2',
  },
  // Column specific styles (adjust widths for each column)
  srNoCell: {
    width: '10%', // First column with smaller width
  },
  detailsCell: {
    width: '50%', // Second column with larger width
  },
  pageNoCell: {
    width: '15%', // Third column with medium width
  },
});


const FamilyDetails = ({ result }) => {
  
  // Make sure childDetails exists and initialize it as an array if it doesn't
  const childDetails = result.childDetails || [];
  
  const tableData = [
    ['1',  result.spouseName || '--', result.spouseDOB || '--', result.spouceRelation || '--'],
    ['2', childDetails[0]?.nameChild || '--', childDetails[0]?.dobChild || '--', childDetails[0]?.relationship || '--'],
    ['3', childDetails[1]?.nameChild || '--', childDetails[1]?.dobChild || '--', childDetails[1]?.relationship || '--'],
  ];
  
  
  
 return (
  <View style={style.page}>
                   <Text style={[style.subtitle, {textAlign: 'left'}]}>Enclosures of form No.5. (item 9)</Text>
                
                   <Text style={[style.title, style.ArialBlack]}>Form 3</Text>
                   <Text style={[style.subtitle, style.ArialItalic]}>[See rule 116(14)]</Text>
                   <View style={style.solidLine} />

     <Text style={[style.title, style.ArialBold, {marginBottom: 40}]}>Details of Family</Text>


    <AutoText style={style.paragraph}>Name of the Government Servant: {result.employeeName}</AutoText>
    <Text style={style.paragraph}>Designation: {result.designation}</Text>
        <Text style={style.paragraph}>Date of appointment: {result.dateOfAppointment}</Text>
        <Text style={style.paragraph}>Details of the Members of Family as on : ____________</Text>

     {/* Table */}
     <View style={styles.table}>
      {/* Header Row */}
      <View style={[styles.row, styles.headerCell]}>
        <Text style={[styles.cell, styles.srNoCell]}>Sr. No</Text>
        <Text style={[styles.cell, styles.detailsCell]}>Name of the Member of Family</Text>
        <Text style={[styles.cell, styles.pageNoCell]}>Date of Birth</Text>
        <Text style={[styles.cell, styles.pageNoCell]}>Relationship with the Govt.Servant</Text>
        <Text style={[styles.cell, styles.pageNoCell]}>Signature of Head of Office</Text>
        <Text style={[styles.cell, styles.pageNoCell]}>Remarks</Text>
      </View>
      
       {/* Table Data */}
       {tableData.map(([srNo, name, dob, Relationship], index) => (
        <View style={styles.row} key={index}>
          <Text style={[styles.cell, styles.srNoCell]}>{srNo}</Text>
          <AutoText style={[styles.cell, styles.detailsCell]}>{name}</AutoText>
          <Text style={[styles.cell, styles.pageNoCell]}>{dob}</Text>
          <Text style={[styles.cell, styles.pageNoCell]}>{Relationship}</Text>
          <Text style={[styles.cell, styles.pageNoCell]}></Text>
          <Text style={[styles.cell, styles.pageNoCell]}></Text>
          
        </View>
      ))}
    </View>

    <Text style={[style.paragraph,{marginTop: 50}]}>I hereby undertake to keep the above particulars up to date by notifying to the Audit Officer / Head of office any addition or alteration.</Text>

    <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 40 }}>
                <Text>Place:  {result.placeOfRetirement}</Text>
                <Text style={[ style.ArialItalic,{ fontSize: 8 },{marginRight :50}]}>Head of Office</Text>
              </View>

              <Text style={{ marginTop: 5 }}>Date:</Text>
  </View>
)};

export default FamilyDetails;
